import React, { FC } from 'react'

import { Icon, IconColor, IconName } from './Icon'

type Props = {
  inactiveName: IconName
  inactiveColor?: typeof IconColor[keyof typeof IconColor]
  activeName: IconName
  activeColor?: typeof IconColor[keyof typeof IconColor]
  isActive: boolean
}

export const IconStack: FC<Props> = ({
  inactiveName,
  inactiveColor = IconColor.GRAY_1,
  activeName,
  activeColor = IconColor.GRAY_1,
  isActive
}) => (
  <span
    style={{
      position: 'relative',
      flexShrink: 0,
      width: 20,
      height: 20,
      margin: '0 10px'
    }}
  >
    <Icon name={inactiveName} color={inactiveColor} style={{ opacity: isActive ? 0 : 1 }} />
    <Icon
      name={activeName}
      color={activeColor}
      style={{ position: 'absolute', top: 0, left: 0, opacity: isActive ? 1 : 0 }}
    />
  </span>
)
